import { Component, ElementRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { combineLatest, Observable } from 'rxjs';
import { filter, map, mergeMap, shareReplay, take } from 'rxjs/operators';
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from "../services/auth/auth.service";
import { MatDrawer } from "@angular/material/sidenav";
import { FileUploadPopupComponent } from "../common/file-upload-popup/file-upload-popup.component";
import { SettingsComponent } from "../settings/settings.component";
import { ApiKeyComponent } from "../api-key/api-key.component";
import { environment } from "../../environments/environment";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ImpersonationEndDialogComponent } from '../settings/impersonation-end-dialog/impersonation-end-dialog.component';
import { SessionSignalService } from '../services/end-session-signal.service';


@Component({
	selector: 'app-layout',
	templateUrl: './layout.component.html',
	styleUrls: ['./layout.component.scss'],
	encapsulation: ViewEncapsulation.None,
	standalone: false
})
export class LayoutComponent {
	isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
		.pipe(
			map(result => result.matches),
			shareReplay()
		);
	fullPageTemplate = false;
	env: any;
	isAdmin = false;
	token: any;
	isLoading = false;
	logo = '';
	isPyrocast = true;
	isTune2 = false;
	ignite = false;
	contactUsLink = '';
	FAQLink = '';
	endImpersonationLoader = false
	forceImpersonationSessionEnd = false
	countdown = 10;
	exp: number | null = null
	private countdownInterval: any;
	@ViewChild('drawer') drawer!: MatDrawer;
	constructor(
		public authService: AuthService,
		private breakpointObserver: BreakpointObserver,
		private route: ActivatedRoute,
		private router: Router,
		public dialog: MatDialog,
		public _snackBar: MatSnackBar,
		private sessionSignal: SessionSignalService) {
		this.env = environment;
		this.authService.isAdmin.subscribe((status: any) => {
			this.isAdmin = status;
		});
		this.authService.token.subscribe((token: any) => {
			this.token = token;
		});

		// this.authService.exp.subscribe((exp: any) => {
		// 	console.log("In Auth", Number(exp))
		// 	console.log(authService.isImpersonating.value)
		// 	this.exp = Number(exp);

		// 	if (authService.isImpersonating.value) {

		// 		if (this.exp == null) {
		// 			const now = Math.floor(Date.now() / 1000);
		// 			const diff = this.exp! - now;
		// 			this.countdown = diff;
		// 		}

		// 		this.startCountdown();
		// 	}
		// });

		combineLatest([
			this.authService.exp,
			this.authService.isImpersonating
		]).subscribe(([exp, isImpersonating]) => {


			if (isImpersonating) {


				if (exp != null && exp != '') {
					this.exp = Number(exp);
					const now = Math.floor(Date.now() / 1000);
					const diff = this.exp - now;
					this.countdown = diff;
				}

				this.startCountdown();
			}
		});

		if (window.location.hostname == environment.skyDomain) {
			this.logo = 'skystream_logo.png';
			this.isPyrocast = false;
			this.ignite = false;
		}
		else if (window.location.hostname == environment.igniteDomain) {
			this.logo = 'IGNITE_Live_Logo.png';
			this.isPyrocast = true;
			this.isTune2 = false;
			this.ignite = true;
		}
		else if (window.location.hostname == environment.tune2Domain || window.location.hostname == environment.tune2Domain2) {
			this.logo = 'tune2-logo.webp';
			this.isPyrocast = false;
			this.isTune2 = true;
			this.ignite = false;
		}
		else {
			this.logo = 'pyrocast-logo.webp';
		}
		this.authService.refreshToken();

		if(this.ignite){
			this.FAQLink = "https://help.ignitefiringsystems.com/hc/en-us/sections/46787095044123-IGNITE-LIVE-FAQ"
			this.contactUsLink = "https://help.ignitefiringsystems.com/hc/en-us/requests/new?ticket_form_id=5657571032219"
		}
		else{
			this.FAQLink = "https://www.pyrocast.com/faqs"
			this.contactUsLink = "https://www.pyrocast.com/contact-us"
		}
  }

	formatDuration(ms: number): string {
		if (!ms || ms < 0) return '0s';

		const totalSeconds = Math.floor(ms / 1000);
		const hours = Math.floor(totalSeconds / 3600);
		const minutes = Math.floor((totalSeconds % 3600) / 60);
		const seconds = totalSeconds % 60;

		if (hours > 0) {
			return `${hours}h : ${minutes}m : ${seconds}s`;
		} else if (minutes > 0) {
			return `${minutes}m : ${seconds}s`;
		} else {
			return `${seconds}s`;
		}
	}
	settings() {
		const dialogRef = this.dialog.open(SettingsComponent, {
			id: 'settings',
			maxWidth: '600px',
			width: '100%',
		});
		dialogRef.afterClosed().subscribe(newValue => { })
	}
	apiKey() {
		const dialogRef = this.dialog.open(ApiKeyComponent, {
			id: 'api-key',
			maxWidth: '600px',
			width: '100%',
		});
		dialogRef.afterClosed().subscribe(newValue => { })
	}

	closeDrawer() {
		this.isHandset$.subscribe(response => {
			if (response) {
				this.drawer.close();
			}
		});
	}

	linkedUserLogin(email: string) {
		this.isLoading = true;
		this.authService.linkedUserLogin(email).subscribe((response) => {
			this.isLoading = false;
			localStorage.setItem('token', response.token);
			window.location.href = 'home';
		}, (error: any) => {
			this.isLoading = false;
			this._snackBar.open(error.error.error, 'Dismiss');
		});
	}

	collaboratorLogin(email: string) {
		this.isLoading = true;
		this.authService.collaboratorLogin(email).subscribe((response) => {
			this.isLoading = false;
			localStorage.setItem('token', response.token);
			window.location.href = 'home';
		}, (error: any) => {
			this.isLoading = false;
			this._snackBar.open(error.error.error, 'Dismiss');
		});
	}

	logout(event: any) {
		this.authService.logout().then(() => {
			window.location.href = '/login';
		});
	}

	ngOnInit() {
		this.sessionSignal.signal$.pipe(
			filter(value => !!value),
			take(1)).subscribe(() => {
				this.forceImpersonationSessionEnd = true
				console.log("Requested to end impersonation session forcefully")
				if (this.countdown > 10) this.countdown = 10
			});

		this.router.events.pipe(
			filter(event => event instanceof NavigationEnd),
			map(() => this.route),
			map(route => {
				while (route.firstChild) route = route.firstChild
				return route
			}),
			filter(route => route.outlet === 'primary'),
			mergeMap(route => route.data)
		).subscribe(data => {
			this.fullPageTemplate = data['fullPageTemplate']
		}
		)
	}



	endImpersonation() {
		const admin_token = localStorage.getItem("admin_token")
		const token = localStorage.getItem("token")
		localStorage.setItem("token", admin_token!)
		this.authService.refreshToken()
		this.endImpersonationLoader = true

		this.authService.endImpersonatingSession(token!).subscribe({
			next: (result: any) => {

				if (result.success) {

					localStorage.removeItem("admin_token")

					const dialogRef = this.dialog.open(ImpersonationEndDialogComponent, {
						width: '400px',
						disableClose: true,
						data: {
							sessionDuration: this.formatDuration(result.sessionDuration)
						}
					});


					//just for better user experience so admin feels he has been redirected back to his account
					dialogRef.afterClosed().subscribe(() => {

						if (this.router.url.startsWith('/session')) this.router.navigate(["/shows"])

						else this.router.navigate(['/session']);
					});

				}

			},
			error: (err) => {
				console.error(err);
			},
			complete: () => {
				this.endImpersonationLoader = false
			}
		});


	}

	startCountdown() {
		clearInterval(this.countdownInterval);
		this.countdownInterval = setInterval(() => {
			this.countdown--;
			if (this.countdown === 0) {
				clearInterval(this.countdownInterval);
				this.endImpersonation(); // or whatever should trigger at 0
			}
		}, 1000);
	}

	ngOnDestroy() {
		clearInterval(this.countdownInterval);
	}


}




